import React, { memo } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Header from "@/components/template/publicTemplate/Header"
import Footer from "@/components/template/publicTemplate/Footer"
import Grid from "@material-ui/core/Grid"

// PublicLayout - validate participant
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    pageContainer: {
        position: "relative",
        minHeight: "100vh",
        height: "100%",
    },
    headerWrapper: {
        flex: "0 1 auto",
        zIndex: 3,
    },
    contentWrapper: {
        flex: "1 1 auto",
        display: "flex",
        flexDirection: "column",
    },
    footerWrapper: {
        flex: "0 1 146px",
        [theme.breakpoints.up("lg")]: {
            flex: "0 1 80px",
        },
    },
}))
const PublicLayout = memo(({ children }) => {
    const classes = useStyles()
    return (
        <>
            <Grid container direction="column" className={classes.pageContainer}>
                <Grid item xs={12} className={classes.headerWrapper}>
                    <Header />
                </Grid>
                <Grid item xs={12} className={classes.contentWrapper}>
                    {children}
                </Grid>
                <Grid item xs={12} className={classes.footerWrapper}>
                    <Footer />
                </Grid>
            </Grid>
        </>
    )
})

export default PublicLayout
